import { trpc } from "../../lib/trpc.js";
import { Botao, Falha, Girando, Selo } from "../../components/ui.js";

/**
 * O estado do WhatsApp da SER, acima das credenciais (#105, pelo WAHA desde o #107).
 *
 * Só leitura. A sessão é do único número da organização, compartilhado com a loja: conectar, reiniciar e desconectar
 * são da infraestrutura da SER, e a chave deste sistema nem alcança essas ações. Daqui se vê se o número está de pé —
 * antes de descobrir no meio de um atendimento.
 */
export function PainelWhatsApp() {
  const utils = trpc.useUtils();
  const status = trpc.whatsapp.status.useQuery();

  if (status.isLoading) {
    return (
      <div className="rounded-peca border border-borda bg-superficie-alta p-4">
        <Girando className="size-5 text-texto-fraco" />
      </div>
    );
  }

  if (status.data?.configurado === false) {
    return (
      <div className="rounded-peca border border-borda bg-superficie-alta p-4">
        <p className="text-[0.9375rem] leading-relaxed text-texto-suave">
          Preencha a chave do WAHA abaixo para ver o estado do WhatsApp da SER.
        </p>
      </div>
    );
  }

  const d = status.data;
  const pronto = d?.conectado === true;

  return (
    <div className="flex flex-col gap-3 rounded-peca border border-borda bg-superficie-alta p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-2">
          <Selo tom={pronto ? "fixado" : "descartar"}>
            {pronto ? "Conectado" : d?.situacao ? "Desconectado" : "Fora do ar"}
          </Selo>
          <span className="text-[0.875rem] text-texto-suave">
            {!pronto && d?.situacao ? `WhatsApp da SER: ${d.situacao}` : "WhatsApp da SER"}
          </span>
        </div>
        <Botao
          tom="fantasma"
          carregando={status.isFetching}
          onClick={() => void utils.whatsapp.status.invalidate()}
        >
          Atualizar
        </Botao>
      </div>

      {d?.erro && <Falha mensagem={d.erro} />}

      <p className="text-[0.8125rem] leading-relaxed text-texto-fraco">
        As fotos saem pela fila, uma por vez. Se o número cair, elas esperam até ele voltar e saem
        sozinhas. Reconectar o número é com a infraestrutura da SER. O estado é consultado no máximo
        uma vez por minuto.
      </p>
    </div>
  );
}
